module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/handCare_0177ac.png";